import DigitalClock from "./DigitalClock.jsx";

const App = () => {
  
  return (
      <DigitalClock/>
  )
}

export default App;
